import React, { SetStateAction } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AccessRightEnum } from '../../../../../../../enum/AccessRightEnum';
import { downloadFile, linkify } from '../../../../../../../shared/functions/Functions';
import { IAllStates } from '../../../../../../../store/rootReducer';
import { IFeedbackData } from './CampaignFeedback';
import EmptyState from '../../../../../../../shared/components/placeholder/EmptyState';
import DOMPurify from 'dompurify';
import FilePlaceholder from '../../../../../../../shared/components/placeholder/FilePlaceholder';
import { Fancybox } from '../../../../../../../shared/components/Fancybox';

interface IProps {
    setIsFormOpened: React.Dispatch<SetStateAction<boolean>>;
    feedbackData: IFeedbackData;
}

const CampaignFeedbackPreview = ({ setIsFormOpened, feedbackData }: IProps) => {
    const { t } = useTranslation();
    const { accessRights } = useSelector((state: IAllStates) => state.auth.user);
    const canUploadFiles = accessRights.includes(AccessRightEnum.CAN_UPLOAD_PRESENTATION);
    return (
        <Row>
            {!!feedbackData?.teamFeedback || !!feedbackData?.feedbackFile?.length ? (
                <>
                    <Col md={3} className="position-relative">
                        <Fancybox>
                            <FilePlaceholder
                                file={feedbackData?.feedbackFile?.[0]}
                                classContent="py-4"
                                classIcon="font-120"
                                nameFancybox="measure-feedback-gallery"
                                handleDownload={() =>
                                    downloadFile(
                                        feedbackData?.feedbackFile?.[0]?.path ?? '/icons/filePlaceholder.png',
                                        feedbackData?.feedbackFile?.[0]?.originalName
                                    )
                                }
                            />
                        </Fancybox>
                    </Col>
                    <Col md={9}>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <div>
                                <h5 className="mb-0">
                                    {feedbackData?.company?.displayName ?? 'Agency partner'} Feedback
                                </h5>
                            </div>
                            {canUploadFiles && (
                                <Button variant="outline-primary" onClick={() => setIsFormOpened(prev => !prev)}>
                                    {t('general.button.edit')}
                                </Button>
                            )}
                        </div>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(linkify(feedbackData?.teamFeedback ?? '-')),
                            }}
                        ></p>
                    </Col>
                </>
            ) : (
                <Col className="d-flex align-items-center justify-content-between">
                    <EmptyState
                        isHorizontalView={true}
                        imgClass="w-40px"
                        iconPath="/icons/img-file-placeholder.png"
                        desc={t('brand.campaign.measure.feedback_not_added')}
                    />
                    {canUploadFiles && (
                        <div className="text-end">
                            <Button variant="outline-primary" onClick={() => setIsFormOpened(prev => !prev)}>
                                {t('general.button.edit')}
                            </Button>
                        </div>
                    )}
                </Col>
            )}
        </Row>
    );
};

export default CampaignFeedbackPreview;
